if (!customElements.get("sticky-atc-panel")) {
  class t extends HTMLElement {
    constructor() {
      super(), this.productSection = this.closest(".cc-main-product"), this.productInfo = this
        .productSection.querySelector(".product-info"), this.productForm = this.productSection
        .querySelector("product-form"), "IntersectionObserver" in window && "MutationObserver" in
        window && this.bindEvents()
    }
    disconnectedCallback() {
      window.removeEventListener("scroll", t.handleScroll)
    }
    bindEvents() {
      let e = new IntersectionObserver(t => {
        t.forEach(t => {
          t.target !== this.productForm || theme.mediaMatches.md ? t.target === this
            .productInfo && theme.mediaMatches.md && this.classList.toggle(
              "sticky-atc-panel--out", t.isIntersecting) : this.classList.toggle(
              "sticky-atc-panel--out", t.boundingClientRect.bottom > 0)
        })
      });
      this.productForm && e.observe(this.productForm), this.productInfo && e.observe(this
        .productInfo), window.addEventListener("scroll", t.handleScroll)
    }
    static handleScroll() {
      document.body.classList.toggle("scrolled-to-bottom", window.scrollY + window.innerHeight +
        100 > document.body.scrollHeight)
    }
  }
  customElements.define("sticky-atc-panel", t)
}
